import { Feedback } from "../types/feedback";
import { getApiBase } from "../utils/config";

export async function createFeedback(
  feedback: Feedback,
  agentId: string,
  accessToken: string
): Promise<Feedback> {
  const API_BASE = getApiBase();
  const res = await fetch(
    `${API_BASE}/${feedback.chatId}/agents/${agentId}/messages/${feedback.chatMessageId}/feedback`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(feedback),
    }
  );
  if (!res.ok) throw new Error("Failed to create feedback");
  return await res.json();
}

export async function updateFeedback(feedback: Feedback, agentId: string) {
  const API_BASE = getApiBase();
  const res = await fetch(
    `${API_BASE}/${feedback.chatId}/agents/${agentId}/feedback/${feedback.id}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(feedback),
    }
  );
  if (!res.ok) throw new Error("Failed to update feedback");
  return await res.json();
}
